<template>
  <div class="customer-railsbank-form-container" v-loading="loading">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-office-building"></i>Edit customer</span>
      </div>
      <el-form
        v-if="customerForm"
        :model="customerForm"
        id="customerForm"
        ref="customerForm"
        label-width="200px"
        size="small"
        :rules="customerFormRules"
        :label-position="device === 'mobile' ? 'top' : 'right'"
      >
        <el-alert v-if="errMsg" :title="errMsg" type="error" show-icon>
        </el-alert>
        <el-row :gutter="50">
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-divider content-position="left">Business</el-divider>
            <el-form-item label="Member Code">
              <el-tag>{{ customerForm.uuid1 }}</el-tag>
            </el-form-item>

            <el-form-item label="Risk Score">
              <el-tag
                effect="dark"
                :color="riskColors[customerForm.kyc.company.riskScore]"
                >{{ customerForm.kyc.company.riskScore.toUpperCase() }}</el-tag
              >
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-divider content-position="left">Status</el-divider>
            <el-form-item label="Status">
              <el-select
                style="width:100%"
                v-model="customerForm.status"
                placeholder="please select status"
              >
                <el-option label="Active" value="active"></el-option>
                <el-option label="Disable" value="disable"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Risk Business">
              <el-switch
                v-model="customerForm.kyc.company.riskBusiness"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-divider content-position="left">KYB Company</el-divider>
            <el-form-item prop="name" label="Company Type">
              <el-select
                style="width:100%"
                v-model="customerForm.kyc.company.companyType"
                placeholder="Select"
              >
                <el-option value="soleTrader" label="Sole Trader"></el-option>
                <el-option value="partnership" label="Partnership"></el-option>
                <el-option value="private" label="Private"></el-option>
                <el-option value="nonProfit" label="Nonprofit"></el-option>
                <el-option
                  value="communityInterest"
                  label="Community Interest"
                ></el-option>
                <el-option value="public" label="Public"></el-option>
                <el-option
                  value="internationalNGO"
                  label="International NGO"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="tradingName" label="Business name">
              <el-input
                v-model="customerForm.kyc.company.registrationName"
              ></el-input>
            </el-form-item>
            <el-form-item prop="registrationNumber" label="Registration Number">
              <el-input
                v-model="customerForm.kyc.company.registrationNumber"
              ></el-input>
            </el-form-item>

            <el-form-item prop="businessNatures" label="Nature of Business">
              <el-select
                style="width:100%"
                v-model="customerForm.kyc.company.businessNatures"
                filterable
                placeholder="Select"
              >
                <el-option
                  v-for="item in natureOfBusinessStandard"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              v-if="customerForm.kyc.company.businessNatures == 'other'"
              prop="businessNaturesOther"
              label="Nature of Business Other"
            >
              <el-input
                v-model="customerForm.kyc.company.businessNaturesOther"
              ></el-input>
            </el-form-item>

            <el-form-item prop="telephone" label="Telephone">
              <el-input
                prefix-icon="el-icon-phone"
                v-model="customerForm.kyc.company.telephone"
              ></el-input>
            </el-form-item>

            <el-form-item prop="webSite" label="Website">
              <el-input
                prefix-icon="el-icon-link"
                v-model="customerForm.kyc.company.website"
              ></el-input>
            </el-form-item>

            <el-form-item prop="email" label="Email Contact">
              <el-input
                prefix-icon="el-icon-message"
                v-model="customerForm.kyc.company.email"
              ></el-input>
            </el-form-item>

            <el-form-item prop="isSoleTrader" label="Sole Trader">
              <el-switch
                v-model="customerForm.kyc.company.isSoleTrader"
              ></el-switch>
            </el-form-item>

            <el-form-item prop="regulateFinancial" label="Financial Business">
              <el-switch
                v-model="customerForm.kyc.company.regulateFinancial"
              ></el-switch>
            </el-form-item>

            <el-divider content-position="left"
              >Registration Address</el-divider
            >
            <el-form-item prop="registrationHouseNumber" label="House Number">
              <el-input
                type="text"
                v-model="customerForm.kyc.company.registrationHouseNumber"
              ></el-input>
            </el-form-item>

            <el-form-item prop="registrationStreet" label="Street">
              <el-input
                type="text"
                v-model="customerForm.kyc.company.registrationStreet"
              ></el-input>
            </el-form-item>

            <el-form-item prop="registrationCity" label="City">
              <el-input
                type="text"
                v-model="customerForm.kyc.company.registrationCity"
              ></el-input>
            </el-form-item>

            <el-form-item prop="registrationPostalCode" label="Post Code">
              <el-input
                type="text"
                v-model="customerForm.kyc.company.registrationPostalCode"
              ></el-input>
            </el-form-item>

            <el-form-item prop="registrationCountry" label="Country">
              <el-select
              style="width:100%"
                v-model="customerForm.kyc.company.registrationCountry"
                filterable
                placeholder="Select"
              >
                <el-option
                  v-for="item in countrise"
                  :key="item.countryCode + ' - ' + item.country"
                  :label="item.countryCode + ' - ' + item.country"
                  :value="item.countryCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-divider content-position="left">Trading Address</el-divider>
            <el-form-item prop="tradingNames" label="Trading name">
              <el-input
                type="text"
                v-model="customerForm.kyc.company.tradingNames"
              ></el-input>
            </el-form-item>

            <el-form-item prop="tradingAddressHouseNumber" label="House Number">
              <el-input
                type="text"
                v-model="customerForm.kyc.company.tradingAddressHouseNumber"
              ></el-input>
            </el-form-item>

            <el-form-item prop="tradingAddressStreet" label="Street">
              <el-input
                type="text"
                v-model="customerForm.kyc.company.tradingAddressStreet"
              ></el-input>
            </el-form-item>

            <el-form-item prop="tradingAddressCity" label="City">
              <el-input
                type="text"
                v-model="customerForm.kyc.company.tradingAddressCity"
              ></el-input>
            </el-form-item>

            <el-form-item prop="tradingAddressPostalCode" label="Post Code">
              <el-input
                type="text"
                v-model="customerForm.kyc.company.tradingAddressPostalCode"
              ></el-input>
            </el-form-item>

            <el-form-item prop="tradingAddressCountry" label="Country">
              <el-select
              style="width:100%"
                v-model="customerForm.kyc.company.tradingAddressCountry"
                filterable
                placeholder="Select"
              >
                <el-option
                  v-for="item in countrise"
                  :key="item.countryCode + ' - ' + item.country"
                  :label="item.countryCode + ' - ' + item.country"
                  :value="item.countryCode"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-divider content-position="left"></el-divider>
            <el-form-item
              prop="expectedVolumeRange"
              label="Expected Volume Range"
            >
              <el-select
              style="width:100%"
                v-model="customerForm.kyc.company.expectedVolumeRange"
                placeholder="Select"
              >
                <el-option value="0-25000" label="0-25000"></el-option>
                <el-option value="25000-50000" label="25000-50000"></el-option>
                <el-option
                  value="50000-250000"
                  label="50000-250000"
                ></el-option>
                <el-option
                  value="250000-1000000"
                  label="250000-1000000"
                ></el-option>
                <el-option value="1000000+" label="1000000+"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              prop="expectedVolumeCurrency"
              label="Expected Volume Currency"
            >
              <el-select
              style="width:100%"
                v-model="customerForm.kyc.company.expectedVolumeCurrency"
                placeholder="Select"
              >
                <el-option value="GBP" label="GBP"></el-option>
                <el-option value="EUR" label="EUR"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="accountUsage" label="Account Usage">
              <el-select
              style="width:100%"
                v-model="customerForm.kyc.company.accountUsage"
                placeholder="Select"
              >
                <el-option
                  value="companyExpenses"
                  label="Company Expenses"
                ></el-option>
                <el-option value="settlements" label="Settlements"></el-option>
                <el-option
                  value="serviceProviderPayments"
                  label="Service Provider Payments"
                ></el-option>
                <el-option
                  value="receiveClientFunds"
                  label="Receive Client Funds"
                ></el-option>
                <el-option
                  value="intragroupTransactions"
                  label="Intragroup Transactions"
                ></el-option>
                <el-option value="other" label="Other"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="customerForm.kyc.company.accountUsage == 'other'"
              prop="accountUsageOther"
              label="Account Usage Other"
            >
              <el-input
                type="text"
                v-model="customerForm.kyc.company.accountUsageOther"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="footer text-center">
        <el-button type="primary" :loading="submiting" @click="submitCustomer()"
          >Submit</el-button
        >
        <el-button @click="cancelForm">Cancel</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import { getUtility } from "@/api/customer";
import { updateCustomer } from "@/api/v2/customer";
import natureOfBusinessStandard from "@/utils/natureOfBusinessStandard.json";
import countrise from "@/utils/map-country-currency.json";
export default {
  props: {
    formData: Object,
  },
  computed: {
    ...mapGetters(["user_project"]),
    device() {
      return this.$store.state.app.device;
    },
  },
  data() {
    return {
      submiting: false,
      dialogShow: false,
      loading: false,
      errMsg: "",
      utility: {},
      customerForm: null,
      customerFormRules: {}, //model.rules,
      natureOfBusinessStandard: [],
      countrise: countrise,
      riskColors: {
        low: "#2ecc71",
        lowMedium: "#3498db",
        medium: "#f9b54a",
        mediumHigh: "#fd5847",
        high: "#bf1200",
      },
    };
  },
  methods: {
    // getUtility() {
    //   getUtility().then(({ result, data }) => {
    //     if (result) {
    //       this.utility = data;
    //     }
    //   });
    // },
    cancelForm() {
      if (this.$route.query.ref && this.$route.query.ref == "customer") {
        this.$router.push(`/project/${this.user_project}?tab=customer`);
      } else if (this.$route.query.ref && this.$route.query.ref == "info") {
        this.$router.push(
          `/customer/view/${this.user_project}/${this.customerForm.enduser_id}`
        );
      } else {
        this.$router.push("/customer");
      }
    },

    getFormData() {
      let formData = JSON.parse(JSON.stringify(this.customerForm));
      delete formData.riskBusiness;
      return formData;
    },

    updateCustomer() {
      let _formData = this.getFormData();
      delete _formData.kyc.identify;
      delete _formData.kyc.personal;
      delete _formData.kyc.venderType;
      this.submiting = true;
      this.errMsg = "";
      const formData = {
        kyc: _formData.kyc,
      };
      updateCustomer(_formData.enduser_id, formData).then(
        ({ result, message }) => {
          this.submiting = false;
          if (result) {
            this.$notify({
              title: "Success",
              message: `Update Customer successfully`,
              type: "success",
              duration: 2000,
            });
            this.cancelForm();
            this.$emit("on-submited", true);
          } else {
            this.errMsg =
              typeof message === "string" ? message : "Update Customer Error";
          }
        }
      );
    },
    submitCustomer() {
      //this.$emit("on-submited", true);
      this.$refs.customerForm.validate((valid) => {
        if (valid) {
          this.updateCustomer();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      if (this.$refs.customerForm) this.$refs.customerForm.resetFields();
    },
  },
  mounted() {
    //this.getUtility();
    this.loading = true;
    setTimeout(() => {
      this.natureOfBusinessStandard = natureOfBusinessStandard;
      this.customerForm = this.formData;
      this.loading = false;
    }, 1800);
  },
};
</script>

<style lang="scss">
.customer-railsbank-form-container {
  .el-form-item--small.el-form-item {
    margin-bottom: 16px;
  }
  .item__label {
    line-height: 30px;
    font-weight: bold;
  }

  .el-form-item__label {
    font-size: 12px;
  }

  .el-divider__text {
    font-weight: bold;
    font-size: 14px;
    color: #424242;
  }

  .footer {
    border-top: 1px solid #ebeef5;
    padding-top: 20px;
    margin-top: 20px;
    margin-left: -20px;
    margin-right: -20px;
  }
}
</style>
